import API from "./api";

// ==============================
// GET ALL INVOICES
// ==============================
export const getAllInvoices = async () => {
  const token = localStorage.getItem("token");

  const res = await API.get("/invoices", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data.invoices;
};

// ==============================
// CREATE INVOICE (IMPORTANT: uses order.id)
// ==============================
export const createInvoice = async (orderId) => {
  const token = localStorage.getItem("token");

  const res = await API.post(
    `/invoices/${orderId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data.invoice;
};

// ==============================
// DELETE INVOICE
// ==============================
export const deleteInvoice = async (id) => {
  const token = localStorage.getItem("token");

  const res = await API.delete(`/invoices/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};